import { render, staticRenderFns } from "./SpotTable.global.vue?vue&type=template&id=d37e4ca0&scoped=true&lang=pug&"
import script from "./SpotTable.global.vue?vue&type=script&lang=ts&"
export * from "./SpotTable.global.vue?vue&type=script&lang=ts&"
import style0 from "./SpotTable.global.vue?vue&type=style&index=0&id=d37e4ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37e4ca0",
  null
  
)

export default component.exports